import React, { useEffect, useState } from 'react'
import { Rating } from 'react-simple-star-rating'

type Props = {
  rating: number,
  setRating?: (value: any) => void,
  view?: boolean
}
export default function StarComponent(props: Props) {

  const { view, rating, setRating } = props
  const [currentRating, setCurrentRating] = useState((rating ?? 0) * 20);

  useEffect(() => {
    setCurrentRating((rating ?? 0) * 20);
  }, [rating]);

  const handleRating = (rate: number) => {
    setCurrentRating(rate);
    if (setRating) setRating(rate)
  }
  return (
    <div>
      {view ?
        <Rating key={`readonly-${rating ?? 0}`} transition={true} readonly={true}  fillColor={"#a77ce6"} allowFraction={true} size={25} initialValue={rating ?? 0} /> :
        <Rating key={`editable-${rating ?? 0}`} transition={true} onClick={handleRating} fillColor={"#a77ce6"} allowFraction={false} initialValue={currentRating / 20} />
      }
    </div>
  )
}
